<script setup>
import { computed } from 'vue'

/** Several values from a short list, as toggle chips. options: [{value, label}] */
const props = defineProps({ modelValue: { type: Array, default: () => [] }, options: { type: Array, default: () => [] }, disabled: Boolean })
const emit = defineEmits(['update:modelValue'])
const set = computed(() => new Set(props.modelValue || []))
function toggle(value) {
  const next = new Set(set.value)
  if (next.has(value)) next.delete(value)
  else next.add(value)
  emit('update:modelValue', props.options.map((o) => o.value).filter((v) => next.has(v)))
}
</script>

<template>
  <div class="field-box-loose flex flex-wrap gap-1.5 rounded-lg">
    <button
      v-for="o in options"
      :key="o.value"
      type="button"
      :disabled="disabled"
      :aria-pressed="set.has(o.value)"
      :class="['rounded-full border px-2.5 py-1 text-xs font-medium transition-colors', set.has(o.value) ? 'border-brand-500 bg-brand-50 text-brand-800 dark:bg-brand-900/40 dark:text-brand-100' : 'border-default text-muted hover:border-brand-300']"
      @click="toggle(o.value)"
    >
      <i v-if="set.has(o.value)" class="fa-solid fa-check mr-1 text-3xs" aria-hidden="true"></i>{{ o.label }}
    </button>
  </div>
</template>
